/*
 * COCO HIT — v12 (subscriptions are opt-in)
 *
 * One-time purchase is always the default. A subscription is only selected when
 * the shopper picks a plan themselves, or arrives on a ?selling_plan= link they
 * clicked from the Subscribe & Save page — stated intent, never a default.
 *
 * The purchase options sit directly above the buy buttons (see
 * templates/product.json block_order) with every frequency on show.
 */
(function () {
  var FREE_SHIPPING_THRESHOLD = 99; // AUD — matches the store's free shipping rule
  var PREFERRED_PLAN = /4\s*-?\s*week/i;
  var userPickedPurchaseOption = false;
  var deepLinkDone = false;

  var CSS = [
    '.coco-sub-benefits{margin:18px 0 0;padding:14px 18px;background:#FFF7EE;border:1px solid #F7E4C8;border-radius:10px;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;}',
    '.coco-sub-benefits .coco-ben-title{font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.2px;text-transform:uppercase;color:#1A1A1A;margin:0 0 8px;}',
    '.coco-sub-benefits ul{list-style:none;margin:0;padding:0;}',
    '.coco-sub-benefits li{font-size:14px;line-height:1.7;color:#1A1A1A;padding-left:22px;position:relative;}',
    '.coco-sub-benefits li::before{content:"\\2714";position:absolute;left:0;top:0;color:#F7941D;font-weight:900;}',
    '.coco-most-popular{display:inline-block;background:#F7941D;color:#fff!important;font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:10px;letter-spacing:1.2px;text-transform:uppercase;padding:3px 8px;border-radius:4px;margin-left:8px;vertical-align:middle;line-height:1.2;}',
    '.coco-most-popular-row{border:2px solid #F7941D!important;border-radius:8px!important;}',

    /* dollar savings on each subscription tier */
    '.coco-save{display:block;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:12px;font-weight:700;color:#C76A0C;margin-top:2px;letter-spacing:.2px;white-space:nowrap;}',
    '.coco-sub-hint{display:block;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:12.5px;font-weight:400;line-height:1.5;color:#1A1A1A;margin:3px 0 6px;}',
    '.coco-sub-hint b{color:#C76A0C;font-weight:800;}',
    /* every frequency is always on show, so keep the rows tight */
    '.coco-sub-promo .group_list_item{padding-top:5px!important;padding-bottom:5px!important;}',
    /* make the subscribe option visibly the better deal */
    '.coco-sub-promo{background:#FFF7EE!important;border:2px solid #F7941D!important;border-radius:10px!important;padding:10px 12px!important;}',
    /* the app lays this row out as flex, which squeezes the title once a badge and pitch are added */
    '.coco-sub-promo .title_and_price_wrapper{display:block!important;}',
    '.coco-sub-badge{display:inline-block;background:#F7941D;color:#fff;font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:10px;letter-spacing:1.1px;text-transform:uppercase;padding:3px 8px;border-radius:4px;margin-left:8px;vertical-align:middle;line-height:1.2;}',
    /* free shipping nudge under the options */
    '.coco-ship-nudge{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:12.5px;line-height:1.5;color:#555;margin:10px 0 0;padding:9px 12px;background:#FFF7EE;border:1px solid #F7E4C8;border-radius:8px;}',
    '.coco-ship-nudge b{color:#1A1A1A;}',

    /* what is about to be added */
    '.coco-buytype{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;margin:12px 0 0;}',
    '.coco-buytype-now{display:flex;align-items:center;gap:8px;font-size:13px;color:#1A1A1A;}',
    '.coco-buytype-now b{font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:11px;letter-spacing:1.2px;text-transform:uppercase;}',
    '.coco-buytype-dot{width:9px;height:9px;border-radius:50%;background:#1A1A1A;flex:0 0 auto;}',
    '.coco-buytype.is-sub .coco-buytype-dot{background:#F7941D;}',

    /* cart drawer offer */
    '.coco-cart-sub{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;background:#FFF7EE;border:2px solid #F7E4C8;border-radius:12px;padding:14px 16px;margin:0 0 14px;}',
    '.coco-cart-sub-t{font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:13px;letter-spacing:.3px;color:#1A1A1A;margin:0 0 4px;}',
    '.coco-cart-sub-s{font-size:12.5px;line-height:1.5;color:#555;margin:0 0 12px;}',
    '.coco-cart-sub-actions{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}',
    '.coco-cart-sub-yes{font-family:"Arial Black",Impact,Helvetica,Arial,sans-serif;font-weight:900;font-size:12px;letter-spacing:1px;text-transform:uppercase;color:#fff;background:#F7941D;border:2px solid #1A1A1A;border-radius:999px;padding:10px 18px;cursor:pointer;box-shadow:0 3px 0 #1A1A1A;}',
    '.coco-cart-sub-yes:disabled{opacity:.6;cursor:default;}',
    '.coco-cart-sub-no{font-size:12.5px;color:#777;background:none;border:none;text-decoration:underline;cursor:pointer;padding:6px 2px;}',

    /* Subscribe & Save page: cadence rows act as a chooser */
    '.coco-cad-row{cursor:pointer;}',
    '.coco-cad-chosen{outline:3px solid #F7941D;outline-offset:2px;}',
    '@media (max-width:600px){.coco-sub-benefits li{font-size:13px;}}'
  ].join('');

  function injectCss() { if (document.getElementById('coco-sub-css')) return; var s = document.createElement('style'); s.id = 'coco-sub-css'; s.appendChild(document.createTextNode(CSS)); document.head.appendChild(s); }
  function buildBenefits() { var d = document.createElement('div'); d.id = 'coco-sub-benefits-wrap'; d.className = 'coco-sub-benefits'; d.innerHTML = '<div class="coco-ben-title">Why subscribe</div><ul><li>Save up to 15% on every delivery</li><li>Skip deliveries anytime</li><li>Swap flavours anytime</li><li>Cancel anytime</li></ul>'; return d; }
  function findAppBlock() { return document.querySelector('.shopify_subscriptions_app_container, .shopify_subscriptions_app_block, .shopify-block.shopify-app-block'); }
  function findSubscriptionGroup() { return document.querySelector('.subscription_group'); }
  function findFourWeekRow() { var rows = document.querySelectorAll('.group_list_item'); for (var i = 0; i < rows.length; i++) { var t = (rows[i].textContent || '').toLowerCase(); if ((t.indexOf('4 week') > -1 || t.indexOf('4-week') > -1) && t.indexOf('one-time') === -1) return rows[i]; } return null; }
  function findOneTimeRow() { return document.querySelector('.group_list_item.one_time_purchase_option_app_block'); }
  function planRadios() { return document.querySelectorAll('input[data-radio-type="selling_plan"]'); }
  function parsePrice(s) { if (!s) return null; var m = String(s).match(/([\d,]+\.\d{2})/); return m ? parseFloat(m[1].replace(/,/g, '')) : null; }

  /*
   * The recurring-purchase consent is long. Keep it visible next to the buy
   * button rather than above it, where it would push the CTA off the screen.
   */
  function relocateConsent() {
    var consent = document.getElementById('shopify-buyer-consent');
    if (!consent) return;
    var anchor = document.getElementById('coco-buytype') || mainProductForm();
    if (!anchor || !anchor.parentNode) return;
    if (anchor.nextSibling === consent) return;
    consent.classList.add('coco-relocated');
    anchor.parentNode.insertBefore(consent, anchor.nextSibling);
  }

  /*
   * Every frequency and its saving is on show at all times — no extra click to
   * discover the options. One-time stays selected until the shopper picks a plan.
   */
  function setupSubscribePromo() {
    var groups = document.querySelectorAll('.subscription_group');
    if (groups.length < 2) return;
    var subGroup = groups[groups.length - 1];
    if (subGroup.hasAttribute('data-coco-promo')) return;
    var header = subGroup.querySelector('.title_and_price_wrapper');
    if (!header) return;
    subGroup.setAttribute('data-coco-promo', '');
    subGroup.classList.add('coco-sub-promo');

    /*
     * Lead with the actual saving rather than a bare percentage, so the better
     * deal is legible at a glance.
     */
    if (!header.querySelector('.coco-sub-hint')) {
      var oneTime = findOneTimeRow();
      var base = parsePrice(oneTime && oneTime.querySelector('input[type="radio"]') &&
        oneTime.querySelector('input[type="radio"]').getAttribute('data-variant-price'));
      var subs = subGroup.querySelectorAll('input[data-radio-type="selling_plan"]');
      var best = null;
      for (var i = 0; i < subs.length; i++) {
        var p = parsePrice(subs[i].getAttribute('data-variant-price'));
        if (p && (best === null || p < best)) best = p;
      }

      var hint = document.createElement('span');
      hint.className = 'coco-sub-hint';
      if (base && best && best < base) {
        var save = base - best;
        var pct = Math.round((save / base) * 100);
        var badge = document.createElement('span');
        badge.className = 'coco-sub-badge';
        badge.textContent = 'Save up to ' + pct + '%';
        header.appendChild(badge);
        hint.innerHTML = 'From <b>$' + best.toFixed(2) + '</b> a delivery — keep <b>$' + save.toFixed(2) +
          '</b> in your pocket every time. Skip, swap or cancel anytime.';
      } else {
        hint.textContent = 'Save up to 15% on every delivery';
      }
      header.appendChild(hint);
    }
  }

  /*
   * Keep one-time purchase selected until the shopper chooses otherwise, so a
   * plain "Add to cart" can never create a subscription by accident.
   */
  function guardOneTimeDefault() {
    if (userPickedPurchaseOption) return;
    var row = findOneTimeRow();
    if (!row) return;
    var oneTime = row.querySelector('input[type="radio"]');
    if (!oneTime || oneTime.checked) return;
    oneTime.checked = true;
    oneTime.dispatchEvent(new Event('change', { bubbles: true }));
    oneTime.dispatchEvent(new Event('click', { bubbles: true }));
  }

  /*
   * A ?selling_plan= link means the shopper clicked "Subscribe" somewhere and
   * told us what they want, so honouring it is intent — not a default.
   */
  function applyDeepLink() {
    if (deepLinkDone) return;
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { deepLinkDone = true; return; }
    var planId = qs.get('selling_plan');
    var wantsSub = qs.get('subscribe');
    if (!planId && !wantsSub) { deepLinkDone = true; return; }

    var radio = planId ? document.querySelector('input[data-selling-plan-id="' + planId + '"]') : null;
    if (!radio) {
      var subs = planRadios();
      if (!subs.length) return; // widget not rendered yet — try again on the next pass
      for (var i = 0; i < subs.length; i++) {
        if (PREFERRED_PLAN.test(subs[i].getAttribute('aria-label') || '')) { radio = subs[i]; break; }
      }
      if (!radio) radio = subs[0];
    }
    deepLinkDone = true;
    userPickedPurchaseOption = true;
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  function watchPurchaseOptions() {
    if (document.body.hasAttribute('data-coco-po-watch')) return;
    document.body.setAttribute('data-coco-po-watch', '');
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || el.type !== 'radio' || !el.closest || !el.closest('.group_list_item')) return;
      if (e.isTrusted) userPickedPurchaseOption = true;
      updateBuyTypeLine();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.isTrusted && e.target && e.target.closest && e.target.closest('.group_list_item')) {
        userPickedPurchaseOption = true;
        setTimeout(updateBuyTypeLine, 60);
      }
    }, true);
  }

  /* ---------- product page ---------- */

  function mainProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var btn = forms[i].querySelector('button[type="submit"], button[name="add"]');
      if (btn && btn.offsetParent !== null && /add to cart/i.test(btn.textContent || '')) return forms[i];
    }
    return null;
  }

  function selectedOptionRow() {
    var radios = document.querySelectorAll('.group_list_item input[type="radio"]');
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].closest('.group_list_item');
    return null;
  }

  function updateBuyTypeLine() {
    var wrap = document.getElementById('coco-buytype');
    if (!wrap) return;
    var row = selectedOptionRow();
    var label = wrap.querySelector('.coco-buytype-label');
    var isSub = !!(row && !row.classList.contains('one_time_purchase_option_app_block'));
    if (isSub) {
      var txt = (row.textContent || '').replace(/\s+/g, ' ').replace(/Save \$[\d.]+ a delivery/i, '')
        .replace(/⭐\s*MOST POPULAR/i, '').replace(/\$[\d.,]+\s*AUD/gi, '').trim();
      label.textContent = 'Subscription — ' + txt;
    } else {
      label.textContent = 'One-time purchase';
    }
    wrap.classList.toggle('is-sub', isSub);
    syncBuyButtonPrice();
  }

  /*
   * The buy button prints the plain variant price, so a selected subscription
   * would advertise the wrong amount. Keep it in step with the chosen option.
   */
  function syncBuyButtonPrice() {
    var form = mainProductForm();
    if (!form) return;
    var btn = form.querySelector('button[type="submit"], button[name="add"]');
    var row = selectedOptionRow();
    if (!btn || !row) return;
    var radio = row.querySelector('input[type="radio"]');
    var price = parsePrice(radio && radio.getAttribute('data-variant-price'));
    if (!price) return;
    var spans = btn.querySelectorAll('span');
    for (var i = spans.length - 1; i >= 0; i--) {
      if (!spans[i].children.length && /\$[\d,]+\.\d{2}/.test(spans[i].textContent || '')) {
        spans[i].textContent = '$' + price.toFixed(2);
        return;
      }
    }
  }

  /* Show the saving in dollars, not just a percentage. */
  function annotateSavings() {
    var subs = planRadios();
    for (var i = 0; i < subs.length; i++) {
      var radio = subs[i];
      var row = radio.closest('.group_list_item');
      if (!row || row.querySelector('.coco-save')) continue;
      var now = parsePrice(radio.getAttribute('data-variant-price'));
      var was = parsePrice(radio.getAttribute('data-variant-compare-at-price'));
      if (!now || !was || was <= now) continue;
      var tag = document.createElement('span');
      tag.className = 'coco-save';
      tag.textContent = 'Save $' + (was - now).toFixed(2) + ' a delivery';
      (row.querySelector('.title_and_price_wrapper') || row).appendChild(tag);
    }
  }

  /*
   * Every description carries a "Pack: 12 × 320ml cans" line, so read the count
   * and the noun from there rather than assuming everything is a can — the 1L
   * COCO'G ships as 6 × 1L bottles.
   */
  function packInfo() {
    var m = (document.body.textContent || '')
      .match(/Pack:\s*(\d+)\s*[×x]\s*[\d.]+\s*(?:ml|L)\s*(cans?|bottles?)/i);
    if (!m) return null;
    var count = parseInt(m[1], 10);
    if (!count) return null;
    return { count: count, unit: /bottle/i.test(m[2]) ? 'bottle' : 'can' };
  }

  /*
   * A single pack never reaches the free shipping threshold, which quietly makes
   * subscribing poor value. Say plainly how many it takes.
   */
  function injectShippingNudge() {
    if (document.getElementById('coco-ship-nudge')) return;
    var subs = planRadios();
    if (!subs.length) return;
    var best = null;
    for (var i = 0; i < subs.length; i++) {
      var p = parsePrice(subs[i].getAttribute('data-variant-price'));
      if (p && (best === null || p < best)) best = p;
    }
    if (!best) return;
    var n = Math.ceil(FREE_SHIPPING_THRESHOLD / best);
    if (n < 2) return;
    var block = findAppBlock();
    if (!block) return;
    var pack = packInfo();
    var note = document.createElement('p');
    note.id = 'coco-ship-nudge';
    note.className = 'coco-ship-nudge';
    note.innerHTML = 'Delivery tip: set your quantity to <b>' + n + ' or more</b> and every delivery ships free ' +
      '(free shipping over $' + FREE_SHIPPING_THRESHOLD + ')' +
      (pack ? ' — just <b>$' + (best / pack.count).toFixed(2) + ' a ' + pack.unit + '</b>.' : '.');
    block.appendChild(note);
  }

  function injectBuyTypeLine() {
    if (document.getElementById('coco-buytype')) return;
    if (!findSubscriptionGroup()) return;
    var form = mainProductForm();
    if (!form || !form.parentNode) return;
    var wrap = document.createElement('div');
    wrap.id = 'coco-buytype';
    wrap.className = 'coco-buytype';
    wrap.innerHTML = '<div class="coco-buytype-now"><span class="coco-buytype-dot"></span>' +
      '<b>Adding:</b> <span class="coco-buytype-label">One-time purchase</span></div>';
    form.parentNode.insertBefore(wrap, form.nextSibling);
    updateBuyTypeLine();
  }

  /* Benefits sit below the buy buttons so they never push the CTA down the page. */
  function injectBenefits() {
    if (document.getElementById('coco-sub-benefits-wrap')) return;
    if (!findSubscriptionGroup()) return;
    var anchor = document.getElementById('coco-buytype') || mainProductForm();
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildBenefits(), anchor.nextSibling);
  }

  /* ---------- cart drawer: subscribe offer before checkout ---------- */

  var productCache = {};
  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function planForProduct(p) {
    if (!p || !p.selling_plan_groups || !p.selling_plan_groups.length) return null;
    var plans = p.selling_plan_groups[0].selling_plans || [];
    if (!plans.length) return null;
    for (var i = 0; i < plans.length; i++) if (PREFERRED_PLAN.test(plans[i].name || '')) return plans[i];
    return plans[0];
  }

  function planDiscount(plan) {
    try {
      var adj = plan.price_adjustments && plan.price_adjustments[0];
      if (adj && adj.value_type === 'percentage') return adj.value + '%';
    } catch (e) {}
    return null;
  }

  function eligibleCartLines() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var open = (cart.items || []).filter(function (i) { return !i.selling_plan_allocation; });
      if (!open.length) return [];
      return Promise.all(open.map(function (i) {
        return getProduct(i.handle).then(function (p) {
          var plan = planForProduct(p);
          return plan ? { key: i.key, quantity: i.quantity, planId: plan.id, planName: plan.name, discount: planDiscount(plan) } : null;
        });
      })).then(function (rows) { return rows.filter(Boolean); });
    }).catch(function () { return []; });
  }

  /*
   * The drawer's checkout control is an <input type="submit" name="checkout">,
   * so it carries no text — match on the name, then hand back the button block
   * so the offer can sit directly above it.
   */
  function drawerCheckoutHost() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return null;
    var checkout = drawer.querySelector('[name="checkout"]');
    if (!checkout) {
      var els = drawer.querySelectorAll('button, a');
      for (var i = 0; i < els.length; i++) {
        if (/check\s*out/i.test(els[i].textContent || '')) { checkout = els[i]; break; }
      }
    }
    if (!checkout) return null;
    var host = checkout.closest('div.border-t-section') || checkout.closest('form') || checkout.parentElement;
    return host && host.parentNode ? host : null;
  }

  function applySubscription(lines, btn) {
    btn.disabled = true;
    btn.textContent = 'Updating…';
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: l.key, quantity: l.quantity, selling_plan: l.planId })
        });
      });
    });
    chain.then(function () {
      var banner = document.getElementById('coco-cart-sub');
      if (banner) banner.remove();
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Switch to subscription';
    });
  }

  function injectCartUpsell() {
    if (sessionStorage.getItem('cocoCartSubDismissed') === '1') return;
    if (document.getElementById('coco-cart-sub')) return;
    if (!drawerCheckoutHost()) return;

    eligibleCartLines().then(function (lines) {
      if (!lines.length) return;
      if (document.getElementById('coco-cart-sub')) return;
      var host = drawerCheckoutHost();
      if (!host || !host.parentNode) return;
      injectCss();

      var save = lines[0].discount ? ('save ' + lines[0].discount) : 'save up to 15%';
      var freq = (lines[0].planName || '').replace(/,.*$/, '').toLowerCase();

      var box = document.createElement('div');
      box.id = 'coco-cart-sub';
      box.className = 'coco-cart-sub';
      box.innerHTML =
        '<p class="coco-cart-sub-t">Make it a subscription and ' + save + '</p>' +
        '<p class="coco-cart-sub-s">Same order, ' + (freq || 'delivered regularly') +
        '. Skip, swap flavours or cancel anytime.</p>' +
        '<div class="coco-cart-sub-actions">' +
        '<button type="button" class="coco-cart-sub-yes">Switch to subscription</button>' +
        '<button type="button" class="coco-cart-sub-no">No thanks</button></div>';

      host.parentNode.insertBefore(box, host);
      box.querySelector('.coco-cart-sub-yes').addEventListener('click', function () { applySubscription(lines, this); });
      box.querySelector('.coco-cart-sub-no').addEventListener('click', function () {
        sessionStorage.setItem('cocoCartSubDismissed', '1');
        box.remove();
      });
    });
  }

  function watchCartDrawer() {
    ['theme:cart-drawer:open', 'theme:cart-drawer:opening', 'cart-is-open', 'cart-will-open', 'shapes:cart:update', 'theme:cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(injectCartUpsell, 350); });
    });
  }

  /* ---------- Subscribe & Save page ---------- */

  /*
   * The flavour cards used to link to a bare product URL, so a shopper who
   * clicked "Subscribe" landed on a one-time page at full price. Carry the
   * cadence they picked through to the product page instead.
   */
  function subscribePageInit() {
    if (location.pathname.indexOf('/pages/subscribe') !== 0) return;
    var wrap = document.querySelector('.coco-subscribe');
    if (!wrap) return;
    var rows = [].slice.call(wrap.querySelectorAll('.cad-row'));
    var cards = [].slice.call(wrap.querySelectorAll('.picker-card'));
    if (!rows.length || !cards.length) return;

    var handle = (cards[0].getAttribute('href') || '').split('?')[0].split('/products/')[1];
    if (!handle) return;

    getProduct(handle).then(function (p) {
      if (!p || !p.selling_plan_groups || !p.selling_plan_groups.length) return;
      var plans = p.selling_plan_groups[0].selling_plans || [];
      if (!plans.length) return;
      injectCss();

      function syncPickerLinks() {
        var chosen = wrap.querySelector('.coco-cad-chosen[data-coco-plan]');
        var planId = chosen ? chosen.getAttribute('data-coco-plan') : null;
        cards.forEach(function (a) {
          var base = (a.getAttribute('href') || '').split('?')[0];
          a.setAttribute('href', planId ? base + '?selling_plan=' + planId : base);
        });
      }

      rows.forEach(function (row) {
        var weeks = (row.textContent || '').match(/(\d+)\s*weeks?/i);
        if (!weeks) return;
        var plan = null;
        for (var i = 0; i < plans.length; i++) {
          var m = (plans[i].name || '').match(/(\d+)\s*weeks?/i);
          if (m && m[1] === weeks[1]) { plan = plans[i]; break; }
        }
        if (!plan) return;
        row.setAttribute('data-coco-plan', plan.id);
        row.classList.add('coco-cad-row');
        row.addEventListener('click', function () {
          rows.forEach(function (r) { r.classList.remove('coco-cad-chosen'); });
          row.classList.add('coco-cad-chosen');
          syncPickerLinks();
        });
      });

      var popular = wrap.querySelector('.cad-row.popular[data-coco-plan]') || wrap.querySelector('[data-coco-plan]');
      if (popular) popular.classList.add('coco-cad-chosen');
      syncPickerLinks();
    });
  }

  /* ---------- page decoration ---------- */

  function apply() {
    var group = findSubscriptionGroup();
    if (!group) return false;
    injectCss();
    watchPurchaseOptions();
    applyDeepLink();
    guardOneTimeDefault();
    annotateSavings();
    injectShippingNudge();
    injectBuyTypeLine();
    setupSubscribePromo();
    injectBenefits();

    var row = findFourWeekRow();
    if (row && !row.querySelector('.coco-most-popular')) {
      var badge = document.createElement('span');
      badge.className = 'coco-most-popular';
      badge.textContent = '⭐ MOST POPULAR';
      var anchor = row.querySelector('.delivery_frequency, .frequency, span, label') || row;
      anchor.appendChild(badge);
      row.classList.add('coco-most-popular-row');
      relocateConsent();
      updateBuyTypeLine();
      return true;
    }
    relocateConsent();
    return false;
  }

  function init() {
    if (apply()) return;
    var obs = new MutationObserver(function () { if (apply()) obs.disconnect(); relocateConsent(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); relocateConsent(); }, 15000);
  }

  function injectCartEmptyCta() { if (!/\/cart(\b|\/|$)/.test(location.pathname)) return; if (document.querySelector('.coco-shop-back-cta')) return; var bodyText = (document.body.textContent || '').toLowerCase(); if (bodyText.indexOf('cart is currently empty') === -1) return; var emptyP = null; document.querySelectorAll('p, div').forEach(function (el) { if (el.children.length === 0 && /cart is currently empty/i.test(el.textContent)) emptyP = el; }); if (!emptyP) return; var cta = document.createElement('a'); cta.className = 'coco-shop-back-cta'; cta.href = '/collections/coconut-water-range'; cta.textContent = 'Shop the range'; var wrap = document.createElement('div'); wrap.style.textAlign = 'center'; wrap.appendChild(cta); emptyP.parentNode.insertBefore(wrap, emptyP.nextSibling); }
  function fixBuyNowCta() { var divs = document.querySelectorAll('div.inline-rte'); for (var i = 0; i < divs.length; i++) { var el = divs[i]; var t = (el.textContent || '').trim().toUpperCase(); if (t === 'BUY NOW' && el.tagName === 'DIV') { var a = document.createElement('a'); a.href = '/collections/coconut-water-range'; a.className = el.className + ' coco-buy-now-fixed'; a.textContent = 'BUY NOW'; if (el.parentNode) { el.parentNode.style.textAlign = 'center'; el.parentNode.replaceChild(a, el); } } } }

  function replaceTestimonialSection() {
    if (location.pathname !== '/' && location.pathname !== '') return;
    if (document.querySelector('.coco-reviews-block')) return;
    var sections = document.querySelectorAll('section');
    var target = null;
    for (var i = 0; i < sections.length; i++) {
      if (/WOW, THIS IS ONE OF THE BEST/i.test(sections[i].textContent || '')) { target = sections[i]; break; }
    }
    if (!target) return;
    target.classList.add('coco-testimonial-replaced');
    target.style.background = 'rgb(247,191,110)';
    target.style.display = 'block';
    target.style.padding = '0';
    target.style.textAlign = 'center';
    target.innerHTML = '<div class="coco-reviews-block" style="width:100%;max-width:100%;padding:80px 24px;text-align:center;box-sizing:border-box;display:block;"><div style="max-width:760px;margin:0 auto;text-align:center;"><div class="coco-stars" style="font-size:30px;letter-spacing:4px;margin-bottom:12px;line-height:1;">★ ★ ★ ★ ★</div><div class="coco-tag" style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:13px;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:20px;">Loved by the COCO HIT crew</div><h2 class="coco-h" style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:42px;line-height:1.1;letter-spacing:-0.5px;margin:0 0 14px;text-transform:uppercase;text-align:center;">What our crew is saying</h2><p class="coco-sub" style="font-size:17px;margin:0 0 32px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;line-height:1.5;text-align:center;">Real reviews from real people across Australia.</p><div style="display:flex;justify-content:center;gap:14px;flex-wrap:wrap;"><a class="coco-reviews-cta-primary" href="/pages/reviews"><span>Read all reviews</span></a><a class="coco-reviews-cta-secondary" href="/pages/reviews#judgeme_product_reviews"><span>Leave a review</span></a></div></div></div>';
    var ctas = target.querySelectorAll('.coco-reviews-cta-primary, .coco-reviews-cta-secondary');
    ctas.forEach(function(a) {
      a.style.cssText = 'display:inline-block;font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:14px;letter-spacing:1.5px;text-transform:uppercase;padding:14px 28px;border-radius:999px;text-decoration:none;box-shadow:0 4px 0 #C76A0C;';
    });
  }
  function homepageInit() {
    replaceTestimonialSection();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      replaceTestimonialSection();
      if (document.querySelector('.coco-reviews-block') || tries > 12) clearInterval(iv);
    }, 400);
  }
  function cartInit() {
    injectCartEmptyCta();
    fixBuyNowCta();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      injectCartEmptyCta();
      fixBuyNowCta();
      relocateConsent();
      if (tries > 10) clearInterval(iv);
    }, 300);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); cartInit(); homepageInit(); watchCartDrawer(); subscribePageInit(); });
  } else { init(); cartInit(); homepageInit(); watchCartDrawer(); subscribePageInit(); }
})();
